module.exports = __webpack_public_path__ + "static/media/kneecap-up.c85931fb.png";